const categoryColors = {
  "Information Technology": "#38bdf8",
  "Computer Science": "#a3e635",
  "Education": "#fbbf24",
  "Business Administration": "#f472b6",
  "Accountancy": "#818cf8",
  "Hospitality and Tourism": "#fca311",
  "Engineering": "#34d399",
  "Health Sciences": "#f87171",
  "Social Sciences": "#f59e42",
  "Psychology": "#c084fc",
  "Communication and Media Studies": "#60a5fa",
  "Others": "#64748b"
};

export default categoryColors;